"use client";

import { useEffect } from "react";
import { trackClickEvent } from "@/lib/tracking";

export default function NavClient() {
  useEffect(() => {
    const nav = document.getElementById("site-nav");
    if (!nav) return;

    function onClick(e: MouseEvent) {
      const target = (e.target as HTMLElement).closest("a");
      if (!target) return;
      const href = (target as HTMLAnchorElement).getAttribute("href") || "";
      const label = target.textContent?.trim() || (target.getAttribute("aria-label") ?? href);
      if (href) {
        try {
          trackClickEvent("nav_click", href, label);
        } catch (err) {
          // swallow tracking errors
          // eslint-disable-next-line no-console
          console.error("nav tracking error", err);
        }
      }
    }

    nav.addEventListener("click", onClick);
    return () => nav.removeEventListener("click", onClick);
  }, []);

  return null;
}
